import Indicador from "..";
import EditFields from "./components/EditFields";
import { ParamFields } from "./components/ParamFields";
import ReportSummary from "./reports/summary";
import apontamentoReport from "./reports/index";
import { differenceInCalendarDays } from "date-fns";



export default class IPSP extends Indicador {
    static get fullName() {
        return "Intervalo entre Preparo Solo e Plantio";
    }

    static get abbrev() {
        return "IPS/P";
    }
    static get field() {
        return "ipsp";
    }


    static get legacyApontamentoMap() {
        return {
            dataHoraEES: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            trator: "trator",
            implemento: "implemento",
            frente: "frente",

            dataPreparoSolo: {
                newField: "dataPreparoSolo",
                convert: (dt) => {
                    if (dt) {
                        let pats = dt.split('/')
                        let data = new Date(pats[2], pats[1] - 1, pats[0])
                        return data;
                    } else {
                        return null
                    }
                },
            },
            dataInicioPlantio: {
                newField: "dataInicioPlantio",
                convert: (dt) => {
                    if (dt) {
                        let pats = dt.split('/')
                        let data = new Date(pats[2], pats[1] - 1, pats[0])
                        return data;
                    } else {
                        return null
                    }
                },
            },

            conformidadeAmostra: "conformidade",
            observacaoAmostra: "observacao",


            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {


            MetaIntervaloPreparoSoloPlantioManual: "manual.meta",

            MetaIntervaloPreparoSoloPlantioMecanizado: "mecanizado.meta",

            classificacaoInterPreparoSoloPlantio: {
                type: Array,
                newField: "items",
                paramMap: {
                    IPSPclassificacao: "classificacao",
                    IPSPclassificacaoIntervaloMin: "intervaloMin",
                    IPSPclassificacaoIntervaloMax: "intervaloMax",
                    sinalIntervaloMin: "sinalIntervaloMin",
                    sinalIntervaloMax: "sinalIntervaloMax",
                },
            },
        };
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return apontamentoReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat
        //return Intervalo de dias dataInicioPlantio -  dataPreparoSolo
        if (!apontamento || !apontamento.dataPreparoSolo || !apontamento.dataInicioPlantio) {
            return 0;
        }


        let conformidade = 0

        // let diferenca = Math.abs(new Date(apontamento.dataPreparoSolo).getTime() - new Date(apontamento.dataInicioPlantio).getTime())
        // conformidade = Math.ceil(diferenca / (1000 * 60 * 60 * 24));
        conformidade = differenceInCalendarDays(
            new Date(apontamento.dataInicioPlantio),
            new Date(apontamento.dataPreparoSolo)
        )

        apontamento.acima = params?.meta && conformidade > f(params.meta) ? 1 : 0
        apontamento.abaixo = 0

        return conformidade;
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 83.33, 100, 116);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;


            if (this.calcPontoAmostradoColeta(item, apontamento.conformidade)) {
                count++;
            }


            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getResultStr(apontamento) {
        return ""
    }
}
